export const DEFAULT_ACTION_TITLES = {
    FREE: 'playtech.mobile.system.getFreeBonus',
    OPT_IN: 'playtech.mobile.system.optIn',
    OPT_OUT: 'playtech.mobile.system.optOut',
    BUY_IN: 'playtech.mobile.system.buyIn',
    FREE_SPINS: 'playtech.mobile.system.freespin',
    DEPOSIT: 'playtech.mobile.system.deposit',
    SIGN_UP: 'playtech.mobile.system.login.button.join_now',
    LOGIN: 'playtech.mobile.system.login.button.login',
    GOLDEN_CHIPS: 'playtech.mobile.system.goldenChips'
};
